'use client';

import { TRACKED_PROPERTIES } from '@/constants';
import { useUser } from '@clerk/nextjs';
import { useClientConfig } from '@spikemark/core';
import mixpanel from 'mixpanel-browser';
import Script from 'next/script';
import { useEffect } from 'react';
export const TrackerScript = ({
  apiKey
}: {
  apiKey?: string;
}) => {
  const trackingEnabled = apiKey !== 'MixPanelApiKey';
  const {
    mixpanel: {
      sessionReplayPercent
    }
  } = useClientConfig();
  const {
    user
  } = useUser();

  //To-DO: Review Mixpanel tracking properties
  useEffect(() => {
    if (trackingEnabled) {
      mixpanel.identify(user?.id ?? 'anonymous');
      mixpanel.people.set({
        [TRACKED_PROPERTIES.user.id]: user?.id,
        [TRACKED_PROPERTIES.user.name]: user?.fullName
      });
    }
  }, [apiKey, trackingEnabled, user?.fullName, user?.id]);
  return <Script id="tracker-script" data-sentry-element="Script" data-sentry-component="TrackerScript" data-sentry-source-file="tracker.tsx">
      {mixpanel.init(trackingEnabled ? apiKey! : ' ', {
      track_pageview: true,
      record_sessions_percent: sessionReplayPercent,
      record_mask_text_selector: ''
    })}
    </Script>;
};
export { mixpanel as tracker };